import { render } from "./QuadrasBanner.vue?vue&type=template&id=aeb65660&scoped=true&ts=true"
import script from "./QuadrasBanner.vue?vue&type=script&lang=ts"
export * from "./QuadrasBanner.vue?vue&type=script&lang=ts"

import "./QuadrasBanner.vue?vue&type=style&index=0&id=aeb65660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb65660"]])

export default __exports__